import { Card, Checkbox, Dropdown, Menu, Row } from 'antd';
import React, { useContext } from 'react';

import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import useProfily from 'hooks/useProfily';

import { EProfilyTyp } from 'enums/profilyTyp';

interface IDropdownMenu {}

const DropdownMenu: React.FC<IDropdownMenu> = () => {
    const { profily, serviceMode } = useContext(Context);
    const { setLevel } = useProfily();

    const menu = (
        <Menu>
            <Card
                style={{
                    padding: 0,
                    width: 400
                }}
                title={`${profily?.jmeno} ${profily?.prijmeni}`}
                styles={{
                    header: {
                        padding: 0,
                        height: 40,
                        minHeight: 0,
                        lineHeight: 1,
                        paddingLeft: 20
                    },
                    body: {
                        padding: '8px 18px'
                    }
                }}
                bordered={false}
            >
                <Row
                    justify="space-between"
                    style={{
                        position: 'relative',
                        top: -10,
                        height: 28
                    }}
                >
                    <p>
                        <TranslateText>TELEFON</TranslateText>:
                    </p>
                    <p>{profily?.telefon1}</p>
                </Row>
                <Row
                    justify="space-between"
                    style={{
                        position: 'relative',
                        top: -10,
                        height: 28
                    }}
                >
                    <p>
                        <TranslateText>EMAIL</TranslateText>:
                    </p>
                    <p>{profily?.email}</p>
                </Row>
                {profily?.posledniprihlaseni && (
                    <Row
                        justify="space-between"
                        style={{
                            position: 'relative',
                            top: -10,
                            height: 28
                        }}
                    >
                        <p>
                            <TranslateText>POSLEDNI_PRIHLASENI</TranslateText>:
                        </p>
                        <p>{profily?.posledniprihlaseni}</p>
                    </Row>
                )}
                {profily?.datumregistrace && (
                    <Row
                        justify="space-between"
                        style={{
                            position: 'relative',
                            top: -10,
                            height: 28
                        }}
                    >
                        <p>
                            <TranslateText>DATUM_REGISTRACE</TranslateText>:
                        </p>
                        <p>{profily?.datumregistrace}</p>
                    </Row>
                )}
                <Row
                    justify="space-between"
                    style={{
                        position: 'relative',
                        top: -10,
                        height: 28
                    }}
                >
                    <p>
                        <TranslateText>AUTH_PRVEK</TranslateText>:
                    </p>
                    <p>
                        <TranslateText>{'TYP_PRIHLASENI_' + profily?.typprihlaseni}</TranslateText>
                    </p>
                </Row>
                {profily?.sezpristupu && profily?.sezpristupu?.filter(e => e.typ === EProfilyTyp.TEXTY).length > 0 && (
                    <Row
                        justify="space-between"
                        style={{
                            position: 'relative',
                            top: -10,
                            height: 28
                        }}
                    >
                        <p>
                            <TranslateText>EDITACNI_MOD</TranslateText>:
                        </p>
                        <Checkbox
                            onChange={() => setLevel('serviceMode', !serviceMode)}
                            checked={serviceMode}
                            style={{
                                position: 'relative',
                                top: -2,
                                left: 4
                            }}
                        />
                    </Row>
                )}
            </Card>
        </Menu>
    );
    return (
        <Dropdown className="app-menu-dropdown-arrow" overlay={menu}>
            <Title
                text={`${profily?.jmeno} ${profily?.prijmeni}`}
                level={5}
                style={{
                    marginTop: '14px',
                    paddingLeft: '6px',
                    textAlign: 'right',
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: '18px',
                    height: '20px',
                    fontWeight: '600',
                    marginRight: '26px'
                }}
            />
        </Dropdown>
    );
};

export default DropdownMenu;
